/**
 * @module businessComponents\mdl\materialTypeNavigation
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Model, Watch } from "vue-property-decorator";
import GhInvoke from "@/components/ghInvoke/ghInvoke";
import GhTree from "@/components/ghTree/ghTree";

@Component
export default class MaterialTypeNavigation extends Vue {
  @Model("change")
  private value!: any;

  @Prop({ default: true })
  private attachedAll!: boolean;

  @Prop()
  private parentId!: string;

  @Prop({ default: true })
  private showToolbar!: any;

  @Prop({ default: 1 })
  private expandLevel!: number;

  private expandAll = false;

  private data: any = [];

  // private get listeners() {
  //   return Object.assign({},this.)
  // }

  private loadedData(data) {
    this.$emit("complete", data);
  }

  private get currentNode() {
    return this.value;
  }

  private set currentNode(value) {
    this.$emit("change", value);
  }

  private get args() {
    let args = {
      parent_id: this.parentId,
      columns: null,
      attached_all: this.attachedAll
    };
    return args;
  }

  @Watch("args")
  public query() {
    if (this.inv) {
      this.inv.invoke(this.args);
    }
  }

  private get inv(): GhInvoke {
    return this.$refs.inv as GhInvoke;
  }

  private getTreeData(data) {
    if (data instanceof Array) {
      return data;
    }
    return [data];
  }

  private test(pre, next, pos) {
    console.log(pre, next, pos);
  }
}
